import { render, staticRenderFns } from "./Scaffolder.vue?vue&type=template&id=29389658&"
import script from "./Scaffolder.vue?vue&type=script&lang=js&"
export * from "./Scaffolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports